import styled from 'styled-components'
import { rem } from 'polished'
import { aiGlowRotatingBorderLayer } from 'lib/aiGlow/aiGlow'

const Shell = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  border-radius: inherit;
  box-shadow: 0 0 ${rem(6)} ${props => props.theme.palette.product.ai.light35},
              0 0 ${rem(12)} ${props => props.theme.palette.product.ai.dark25};
`

/*
 * The mask keeps only the 2px padding band visible, so the ring has a fully
 * transparent interior and whatever it overlays shows through unchanged.
 * The band must be padding (not border): overflow clipping stops at the
 * padding edge, so a border band would never intersect the clipped gradient.
 * The mask would also clip an outer box-shadow, which is why the soft glow
 * shadow lives on the Shell instead.
 */
const Ring = styled.div`
  ${aiGlowRotatingBorderLayer}
  position: absolute;
  inset: 0;
  padding: ${rem(2)};
  border-radius: inherit;
  overflow: hidden;
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
`

interface Props {
  'data-testid'?: string
}

function AIGlowRing(props: Props) {
  const { 'data-testid': dataTestId } = props

  return (
    <Shell data-testid={dataTestId} aria-hidden="true">
      <Ring />
    </Shell>
  )
}

export default AIGlowRing
